// useRBDMClubDropdownQuery.ts
import { useQuery } from '@tanstack/react-query';
import { APICONFIG } from '@config/api.config';
import { APIService } from '@services/api/common-services';
import { IQueryResponse } from '@services/api';
import { RBDMClubDropdownResponse } from '.';

export const useRBDMClubDropdownQuery = (cmdiCode: string = ''): IQueryResponse<RBDMClubDropdownResponse[]> => {
	const dropdwonApiConfig = `${APICONFIG.RBDM_CLUB_DROPDOWN}/`;
	const fetchRBDMClubDropdown = async (): Promise<RBDMClubDropdownResponse[]> => {
		const response = await APIService.getData<RBDMClubDropdownResponse[]>(dropdwonApiConfig, {
			cmdi_code: cmdiCode,
			limit: '0',
		});
		return response || [];
	};

	const { data, error, isLoading, isPending, isFetching } = useQuery({
		queryKey: ['rbdm-club-dropdown', cmdiCode],
		queryFn: fetchRBDMClubDropdown,
		enabled: !!cmdiCode,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		isFetching,
	};
};
